import moment from 'moment'
const accounting = require('accounting')

const moneyConfig = {
	decimal: ',',
	thousands: '.',
	prefix: '',
	suffix: '',
	precision: 2,
	masked: false
}

const accountingConfig = {
	number: {
		precision : moneyConfig.precision,
		thousand: moneyConfig.thousands,
		decimal : moneyConfig.decimal
	}
}

accounting.settings = accountingConfig


const dateFormat = 'DD/MM/YYYY'
const serverDateFormat = "MM/DD/YYYY"
const timeFormat = 'HH:mm'
const locale = "America/Santiago"

const formatTime = (time) => {
	return moment('01/01/2020' + ' ' + time, dateFormat + timeFormat + ':00').format(timeFormat)
}

const getLocaleTime = (date) => {
	let locale = moment(date, locale).utc().format(dateFormat)
	return locale
}

const sortArray = (array, sortField, direction = 'ASC') => {
	array.sort((a,b) => {
		if (a[sortField] > b[sortField]) {
			return (direction == 'ASC') ? 1 : -1
		}
		if (a[sortField] < b[sortField]) {
			return (direction == 'ASC') ? -1 : 1
		}
		return 0
	})
	return array
}

const formatNumber = (number) => {
	return accounting.formatNumber(number);
}

export {
	dateFormat,
	formatTime,
	formatNumber,
	getLocaleTime,
	locale,
	moneyConfig,
	serverDateFormat,
	sortArray,
	timeFormat
}